import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Auto-scroll to top whenever the route changes so link clicks feel responsive. */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
